import UserManagement from './UserManagement';
import { USER_MANAGEMENT } from './userManagement.navigation';

const userManagementRoute = { ...USER_MANAGEMENT, component: UserManagement };

export default userManagementRoute;
